import { useCallback, useEffect, useMemo, useState } from "react"
import styles from "./index.module.scss"
import { Button, Input, message, Popover, Space } from "antd"
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons'

const defaultAnnotations = [
    // [{ label: '默认标签', value: '默认值' }],
    // [{ label: '默认标签', value: '默认值' }],
    // [{ label: '默认标签', value: '默认值' }],
    // [{ label: '默认2142412我去期间巫婆二紧哦碰紧哦碰241欧派4 jl标签', value: '默认值' }],
    // [{ label: '默认标签', value: '默认值' }],
    // [{ label: '默认2142412我去期间巫婆二紧哦碰紧哦碰241欧派4 jl标签', value: '默认值' }],
    // [{ label: '默认2142412我去期间巫婆二紧哦碰紧哦碰241欧派4 jl标签', value: '默认值' }],
    // [{ label: '默认2142412我去期间巫婆二紧哦碰紧哦碰241欧派4 jl标签', value: '默认值' }],
]

export default function PicViewerRight ({
    image = {},
    onFeedback,
}) {
    const {
        title = '-',
        extraInfos = [],
        extraImages = [],
        annotations = [],
        annotationHistory = defaultAnnotations,
        feedbackDisabled=true, // 是否禁止反馈按钮
        feedback=null, // 反馈内容
    } = image

    const allAnnotations = useMemo(() => [annotations, ...annotationHistory].filter(item => item && item.length), [annotations, annotationHistory])
    const allAnnotationsLength = useMemo(() => {
        return allAnnotations.reduce((acc, cur) => acc + cur.length, 0)
    }, [allAnnotations])

    return (
        <div className={styles.PicViewerRight}>
            <div className={styles.Section}>
                <div className={styles.Title}>图片详情</div>
                <div className={styles.Content}>
                    <div className={styles.InfoList}>
                        <div className={styles.InfoTitle}>{title}</div>
                        {extraInfos.map((item, i) => (
                            <div className={styles.InfoItem} style={{width: "100%"}} key={i}>
                                <div className={styles.Label}>{item.label}</div>
                                <div className={styles.Value}>{item.value || '-'}</div>
                            </div>
                        ))}
                        {extraImages.map((item, i) => (
                            <div className={styles.InfoItem} style={{width: "100%"}} key={i}>
                                <div className={styles.Label}>{item.label}</div>
                                <div className={styles.Value}>
                                    <img key={i} src={item.url} alt="" className={styles.SmallImg} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {allAnnotationsLength > 0 &&
            <div className={`${styles.Section} ${styles.CommentSection}`}>
                <div className={styles.Title}>评论与附件</div>
                <div className={`${styles.Content} ${styles.CommentContent}`}>
                    <div className={styles.InfoList}>
                        {allAnnotations.map((comment, i) => (
                            <div className={styles.InfoItem} key={i}>
                                {/* 修改意见index倒叙 */}
                                <div className={styles.Label}>修改意见{allAnnotations.length - i}</div>
                                <div className={styles.Value}>{comment?.[0]?.label || '-'}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>}
            {feedbackDisabled ? null : <FeedbackRender feedback={feedback} onFeedback={onFeedback} />}
        </div>
    )
}

const dislikeReasons = [
    "人体残缺",
    "面部扭曲",
    "模特不好看",
    "模特不符合需求",
    "场景不符合需求",
    "场景不美观"
]

function FeedbackRender (props) {
    const { feedback, onFeedback } = props
    const [popoverOpen, setPopoverOpen] = useState(false)
    const [feedbackText, setFeedbackText] = useState(feedback?.description || "")
    useEffect(() => {
        setFeedbackText(feedback?.description || "")
    }, [feedback])
    // 点赞
    const isLike = useMemo(() => feedback && feedback?.like == 1, [feedback])
    const isDislike = useMemo(() => feedback && feedback?.like == 0, [feedback])
    const handleLike = useCallback(async (like) => {
        try {
            const feedbackId = feedback?.id
            await onFeedback?.(true, null, feedbackId)
            message.success("反馈成功")
        } catch (err) {
            console.error(err)
        }
    }, [feedback, onFeedback])
    
    const handleFeedbackSubmit = useCallback(async () => {
        try {
            if (!feedbackText.trim()) return message.warning('请先填写修改要求')
            const feedbackId = feedback?.id
            await onFeedback?.(false, feedbackText, feedbackId)
            setPopoverOpen(false)
            message.success("反馈成功")
        } catch (err) {
            console.error(err)
        }
    }, [feedbackText, onFeedback, feedback])
    
    return (
        <div className={`${styles.Section} ${styles.FeedbackSection}`}>
            <div className={`${styles.Title} ${styles.FeedbackTitle}`}>效果反馈</div>
            <div className={`${styles.Content} ${styles.FeedbackContent}`}>
                <div className={styles.FeedbackItem} style={{color: isLike ? "#006EFF" : "#888888"}} onClick={() => handleLike(true)}>
                    <LikeOutlined />
                    <span>好评</span>
                </div>
                <Popover
                    trigger="click"
                    open={popoverOpen}
                    onOpenChange={setPopoverOpen}
                    content={
                        <div
                            style={{
                                width: 385,
                                display:"flex",
                                flexDirection:"column",
                                gap:"12px",
                            }}
                        >
                            <div style={{fontSize: "16px", lineHeight: "30px", color: "#1D1B1B"}}>您对生成结果不满意的原因是什么？</div>
                            <div style={{display:"flex",flexWrap:"wrap", gap:"12px"}}>
                                {dislikeReasons.map((item, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            cursor:"pointer",
                                            width:"120px",
                                            height:"32px",
                                            textAlign:"center",
                                            lineHeight:"32px",
                                            borderRadius:"8px",
                                            border: "1px solid #DEE2E8",
                                            boxSizing: "border-box",
                                            userSelect: "none",
                                        }}
                                        onClick={() => setFeedbackText(pre => pre ? [pre, item].join("、") : item)}
                                    >{item}</div>
                                ))}
                            </div>
                            <Input.TextArea
                                value={feedbackText}
                                placeholder="任何让您不满的原因，都请写在这边"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                                onChange={e => setFeedbackText(e.target.value)}
                            />
                            <div style={{
                                display:"flex",
                                justifyContent:"space-between"
                            }}>
                                <Button style={{width: 178}} onClick={() => setPopoverOpen(false)}>取消</Button>
                                <Button style={{width: 178}} type="primary" onClick={handleFeedbackSubmit}>提交</Button>
                            </div>
                        </div>
                    }
                >
                    <div className={styles.FeedbackItem} style={{color: isDislike ? "#006EFF" : "#888888"}}>
                        <DislikeOutlined />
                        <span>差评</span>
                    </div>
                </Popover>
            </div>
        </div>
    )
}